<ng-scrollbar (clickOutside)="navMob()" style="height: calc(100vh - 56px)">
  <a [routerLink]="['/dashboard']" class="b-brand">
    <img id="main-logo" src="assets/images/logo.png" alt="logo-img" class="logo" />
    <h5 class="mt-2 mb-0">RAPTURE</h5>
  </a>
  <div class="navbar-content">
    <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()">
      @for (item of navigations; track item) {
        @if (item.type === 'group') {
          <app-nav-group [item]="item"></app-nav-group>
        }
        @if (item.type === 'collapse') {
          <app-nav-collapse [item]="item"></app-nav-collapse>
        }
        @if (item.type === 'item') {
          <app-nav-item [item]="item"></app-nav-item>
        }
      }
    </ul>

    <div class="version">
      <!-- <label disabled class="pe-auto">v{{ currentApplicationVersion }}</label> -->
    </div>
  </div>
</ng-scrollbar>
